import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { useVideoManagement } from './UseVideoManagement';
import { VideoUploadButton } from './VideoUploadButton';
import { VideoListComponent } from './VideoListComponent';

export const VideoManager = ({ history, inputKey = Date.now() }) => {
    const {
        videoLinks,
        videosProcessing,
        uploadMouseHover,
        snackBarOpen,
        populateVideoLinks,
        handleUploadVideo,
        handleDeleteVideo,
        handleCopyVideoLink,
        handleMouseEnterUpload,
        handleMouseLeaveUpload,
        setSnackBarOpen,
    } = useVideoManagement(history);

    useEffect(() => {
        populateVideoLinks();
    }, [populateVideoLinks]);

    return (
        <Grid>
            <VideoUploadButton
                onUpload={handleUploadVideo}
                isProcessing={videosProcessing}
                uploadMouseHover={uploadMouseHover}
                onMouseEnter={handleMouseEnterUpload}
                onMouseLeave={handleMouseLeaveUpload}
                inputKey={inputKey}
            />
            <VideoListComponent
                videos={videoLinks}
                onCopyLink={handleCopyVideoLink}
                onDeleteVideo={handleDeleteVideo}
                snackBarOpen={snackBarOpen}
                setSnackBarOpen={setSnackBarOpen}
            />
        </Grid>
    );
};